import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
interface DialogData {
  cnpj: string;
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal-reject.component.html',
  styleUrls: ['./modal-reject.component.scss']
})
export class ModalRejectComponent implements OnInit {

  public formGroup: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ModalRejectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public formBuilder: FormBuilder,
    public snackBar: MatSnackBar
    ) {
      console.log('data', data);
     }

  cancel(): void {
    this.dialogRef.close('cancel');
  }

  submit() {
    if (!this.formGroup.valid) {
      this.snackBar.open("Preencha corretamente os campos e tente novamente.");
      return false;
    }

    
    this.dialogRef.close(this.formGroup.value.reason);
  }

  ngOnInit() {
    

    this.formGroup = this.formBuilder.group(
      {
        reason: [null, [
          Validators.required,
        ]],
      });
  }
}

